module.exports = __webpack_public_path__ + "img/calendar-icon-dark.1cdfa626.svg";